import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import Table from "../../../core/common/dataTable/index";
import useApi from "../../../core/customhook/useApi";
import { useEffect, useState } from "react";
import PredefinedDateRanges from "../../../core/common/datePicker";
import moment from "moment";
import { Moment } from "moment";
import FeatherIcon from "feather-icons-react";
import dayjs from "dayjs";

const TeamattendanceHistory = () => {
  function formatHours(hoursDecimal: number): string {
    const hours = Math.floor(hoursDecimal);
    const minutes = Math.floor((hoursDecimal - hours) * 60);
    const seconds = Math.round(((hoursDecimal - hours) * 60 - minutes) * 60);

    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}`;
  }

  const [empname, setEmpname] = useState("");
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [empdata, setEmpdata] = useState([]);
  const [searchValue, setSearchValue] = useState<string>("");
  const [filteredSuggestions, setFilteredSuggestions] = useState<any[]>([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [attendance, setAttendance] = useState([]);
  const [modalData, setModalData] = useState<any>([]);
  const [callAgain, setCallAgain] = useState(0);
  const [reguStatus, setReguStatus] = useState("");
  const [selectedDateRange, setSelectedDateRange] = useState<{
    from: string;
    to: string;
  }>({
    from: moment().startOf("month").format("YYYY-MM-DD"),
    to: moment().endOf("month").format("YYYY-MM-DD"),
  });

  const {
    data: teamData,
    loading: teamLoading,
    error: teamError,
  } = useApi("/api/manager/team-member", {
    method: "GET",
    autoCall: true,
  });

  useEffect(() => {
    if (teamData?.success) {
      setEmpdata(teamData?.data);
    }
  }, [teamData]);

  const {
    data: attendanceData,
    loading: attendanceLoading,
    error: attendanceErrro,
  } = useApi("/api/team-attendance-details", {
    method: "POST",
    payload: {
      employee_id: searchValue || "",
      from: selectedDateRange.from,
      to: selectedDateRange.to,
    },
    autoCall: true,
    dependencies: [selectedDateRange, searchValue],
  });
  useEffect(() => {
    if (attendanceData?.success) {
      setAttendance(attendanceData?.data);
    }
  }, [attendanceData]);

  const empcolumns = [
    {
      title: "EmpCode",
      dataIndex: "employee_id",
      render: (text: string, record: any) => (
        <Link
          to="#"
          onClick={() => {
            setSearchValue(record.employee_id);
            setEmpname(record.employee_name);
            setModalOpen(false);
          }}
          style={{ textDecoration: "underline", cursor: "pointer" }}
          data-bs-dismiss="modal"
        >
          {text}
        </Link>
      ),
      sorter: (a: any, b: any) => a.employee_id.localeCompare(b.employee_id),
    },
    {
      title: "Employee Name",
      dataIndex: "employee_name",
      render: (text: string, record: any) => (
        <Link
          to="#"
          onClick={() => {
            setSearchValue(record.employee_id);
            setEmpname(record.employee_name);
            setModalOpen(false);
          }}
          style={{ textDecoration: "underline", cursor: "pointer" }}
          data-bs-dismiss="modal"
        >
          {text}
        </Link>
      ),
      sorter: (a: any, b: any) =>
        a.employee_name.localeCompare(b.employee_name),
    },
    {
      title: "Designation",
      dataIndex: "designation", // Change From to designation
      sorter: (a: any, b: any) => a.designation.localeCompare(b.designation),
    },
    {
      title: "Department",
      dataIndex: "department", // Change To to department
      sorter: (a: any, b: any) => a.department.localeCompare(b.department),
    },
    {
      title: "Locatation",
      dataIndex: "branch_name", // Change To to branch_name
      sorter: (a: any, b: any) => a.branch_name.localeCompare(b.branch_name),
    },
  ];

  const columns = [
    {
      title: "EmpID",
      dataIndex: "employee_id",
      sorter: (a: any, b: any) => a.employee_id.localeCompare(b.employee_id),
    },
    {
      title: "Employee Name",
      dataIndex: "employee_name",
      sorter: (a: any, b: any) =>
        a.employee_name.localeCompare(b.employee_name),
    },
    {
      title: "Date",
      dataIndex: "attendance_date",
      render: (text: string) => dayjs(text).format("D MMMM YYYY"), // e.g. 10 October 2025
      sorter: (a: any, b: any) =>
        dayjs(a.attendance_date).unix() - dayjs(b.attendance_date).unix(),
    },
    {
      title: "Shift",
      dataIndex: "shift",
    },
    {
      title: "Shift Time",
      dataIndex: "start_time",
      render: (_: any, record: any) =>
        `${record.start_time} - ${record.end_time}`,
    },
    {
      title: "Punch In",
      dataIndex: "punchin_time_software",
      render: (_: any, record: any) => {
        if (record.regularisation_status === "APPROVED") {
          return record.manager_regn_in_time || "-";
        }
        return (
          record.in_time_machine ||
          record.punchin_time_software ||
          record.self_regn_in_time ||
          "-"
        );
      },
      sorter: (a: any, b: any) =>
        new Date(
          a.manager_regn_in_time ||
            a.in_time_machine ||
            a.punchin_time_software,
        ).getTime() -
        new Date(
          b.manager_regn_in_time ||
            b.in_time_machine ||
            b.punchin_time_software,
        ).getTime(),
    },
    {
      title: "Punch Out",
      dataIndex: "punchout_time_software",
      render: (_: any, record: any) => {
        if (record.regularisation_status === "APPROVED") {
          return record.manager_regn_out_time || "-";
        }
        return (
          record.out_time_machine ||
          record.punchout_time_software ||
          record.self_regn_out_time ||
          "-"
        );
      },
      sorter: (a: any, b: any) =>
        new Date(
          a.manager_regn_out_time ||
            a.out_time_machine ||
            a.punchout_time_software,
        ).getTime() -
        new Date(
          b.manager_regn_out_time ||
            b.out_time_machine ||
            b.punchout_time_software,
        ).getTime(),
    },
    {
      title: "Hours",
      dataIndex: "hours_machine",
      render: (_: any, record: any) => {
        let hoursDisplay = "00:00";

        // Case 1: Manager regularisation approved — use manager_regn_hours directly
        if (
          record.regularisation_status === "APPROVED" &&
          record.manager_regn_hours
        ) {
          hoursDisplay = `${record.manager_regn_hours}`;
        }
        // Case 2: Normal case — use machine/software/self-regn hours and format
        else {
          const hoursDecimal = parseFloat(
            record.hours_machine ||
              record.hours_software ||
              record.self_regn_hours ||
              "0",
          );
          hoursDisplay = hoursDecimal > 0 ? formatHours(hoursDecimal) : "00:00";
        }

        return hoursDisplay;
      },
      sorter: (a: any, b: any) => {
        const getHours = (rec: any) => {
          if (rec.regularisation_status === "APPROVED") {
            return parseFloat(rec.manager_regn_hours || "0");
          }
          return parseFloat(
            rec.hours_machine ||
              rec.hours_software ||
              rec.self_regn_hours ||
              "0",
          );
        };
        return getHours(a) - getHours(b);
      },
    },

    {
      title: "Status",
      dataIndex: "status",
      render: (_text: string, record: any) => {
        // Show holiday name if exists
        if (record.h_name) {
          return (
            <span className="badge bg-info text-light">{record.h_name}</span>
          );
        }

        // Determine badge color based on exact status
        let badgeColor = "";
        switch (record.status) {
          case "P":
            badgeColor = "rgb(40, 167, 69)"; // Green
            break;
          case "HP":
            badgeColor = "rgb(253, 126, 20)"; // Orange
            break;
          case "A":
            badgeColor = "red"; // Red
            break;
          case "SH":
            badgeColor = "rgb(255, 193, 7)";
            break;
          default:
            badgeColor = "rgb(0, 123, 255)"; // Default Blue
        }

        return (
          <span
            className="badge text-light"
            style={{ backgroundColor: badgeColor }}
          >
            {record.status}
          </span>
        );
      },
      sorter: (a: any, b: any) => a.status.localeCompare(b.status),
    },
  ];

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Attendance History</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.employeeDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Attendance</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Attendance History List
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div style={{ position: "relative", width: "500px" }}>
                <input
                  type="text"
                  name="empname"
                  id="employeeSearch"
                  className="form-control pe-5"
                  placeholder="Type name / code"
                  style={{ width: "100%" }}
                  value={empname}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    const value = e.target.value;
                    setEmpname(value);
                    setSearchValue("");

                    if (value.trim()) {
                      const matches = empdata.filter((item: any) =>
                        item.employee_name
                          .toLowerCase()
                          .includes(value.toLowerCase()),
                      );
                      setFilteredSuggestions(matches);
                      setShowSuggestions(true);
                    } else {
                      setFilteredSuggestions([]);
                      setShowSuggestions(false);
                    }
                  }}
                />
                <button
                  type="button"
                  className="btn btn-secondary btn-sm"
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "8px",
                    transform: "translateY(-50%)",
                    padding: "4px 8px",
                  }}
                  onClick={() => setModalOpen(true)}
                  data-bs-toggle="modal"
                  data-bs-target="#bs-example-modal-lg"
                >
                  <FeatherIcon icon="more-horizontal" size="16" />
                </button>
                {showSuggestions && filteredSuggestions.length > 0 && (
                  <ul
                    className="dropdown-menu show"
                    style={{
                      width: "100%",
                      maxHeight: "200px",
                      overflowY: "auto",
                      position: "absolute",
                      zIndex: 1000,
                    }}
                  >
                    {filteredSuggestions.map((item, index) => (
                      <li
                        key={index}
                        className="dropdown-item"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setSearchValue(item.employee_id);
                          setEmpname(item.employee_name);
                          setShowSuggestions(false);
                        }}
                      >
                        {item.employee_name}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="me-3">
                  <div className="input-icon-end position-relative">
                    <PredefinedDateRanges
                      onChange={(start: Moment, end: Moment) => {
                        setSelectedDateRange({
                          from: start.format("YYYY-MM-DD"),
                          to: end.format("YYYY-MM-DD"),
                        });
                      }}
                    />
                    <span className="input-icon-addon">
                      <i className="ti ti-chevron-down" />
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="card-body p-0">
              <Table
                limit={30}
                dataSource={attendance}
                columns={columns}
                Selection={false}
                showSearchInput={true}
              />
            </div>
          </div>
        </div>
        <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>

      <div
        id="apply-modal"
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="apply-modalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="apply-modalLabel">
                Regularization Details
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-6 mb-3">
                  <strong>Attendance Date:</strong>
                  <p className="text-muted">
                    {modalData?.attendance_regn_date || "N/A"}
                  </p>
                </div>

                <div className="col-md-6 mb-3">
                  <strong>Shift Time:</strong>
                  <p className="text-muted">
                    {modalData?.shift_start_time} - {modalData?.shift_end_time}
                  </p>
                </div>

                <div className="col-md-6 mb-3">
                  <strong>Self In Time:</strong>
                  <p className="text-muted">
                    {modalData?.self_regn_in_date}{" "}
                    {modalData?.self_regn_in_time}
                  </p>
                </div>

                <div className="col-md-6 mb-3">
                  <strong>Self Out Time:</strong>
                  <p className="text-muted">
                    {modalData?.self_regn_out_date}{" "}
                    {modalData?.self_regn_out_time}
                  </p>
                </div>

                <div className="col-md-6 mb-3">
                  <strong>Total Self Hours:</strong>
                  <p className="text-muted">
                    {modalData?.self_regn_hours || "N/A"}
                  </p>
                </div>

                {(modalData?.manager_regn_in_date ||
                  modalData?.manager_regn_in_time ||
                  modalData?.manager_regn_out_date ||
                  modalData?.manager_regn_out_time ||
                  modalData?.manager_regn_hours) && (
                  <>
                    <div className="col-md-12">
                      <h6 className="mt-2 mb-3 text-primary">
                        Manager Attendance Details
                      </h6>
                    </div>

                    <div className="col-md-6 mb-3">
                      <strong>Manager In Time:</strong>
                      <p className="text-muted">
                        {modalData?.manager_regn_in_date || "--"}{" "}
                        {modalData?.manager_regn_in_time || "--"}
                      </p>
                    </div>

                    <div className="col-md-6 mb-3">
                      <strong>Manager Out Time:</strong>
                      <p className="text-muted">
                        {modalData?.manager_regn_out_date || "--"}{" "}
                        {modalData?.manager_regn_out_time || "--"}
                      </p>
                    </div>

                    <div className="col-md-6 mb-3">
                      <strong>Total Manager Hours:</strong>
                      <p className="text-muted">
                        {modalData?.manager_regn_hours || "N/A"}
                      </p>
                    </div>
                  </>
                )}

                <div className="col-md-6 mb-3">
                  <strong>Status:</strong>
                  <p>
                    <span
                      className={`badge ${
                        modalData?.regularisation_status === "APPROVED"
                          ? "bg-success"
                          : modalData?.regularisation_status === "REJECTED"
                            ? "bg-danger"
                            : "bg-danger"
                      }`}
                    >
                      {modalData?.regularisation_status || "PENDING"}
                    </span>
                  </p>
                </div>

                <div className="col-md-12 mb-3">
                  <strong>Reason:</strong>
                  <p className="text-muted">{modalData?.reason || "N/A"}</p>
                </div>

                {modalData?.manager_reason && (
                  <div className="col-md-12 mb-3">
                    <strong>Manager Reason:</strong>
                    <p className="text-muted">{modalData?.manager_reason}</p>
                  </div>
                )}

                <div className="col-md-6 mb-3">
                  <strong>Approved By:</strong>
                  <p className="text-muted">
                    {modalData?.approved_by || "N/A"}
                  </p>
                </div>

                <div className="col-md-6 mb-3">
                  <strong>Rejected By:</strong>
                  <p className="text-muted">
                    {modalData?.rejected_by || "N/A"}
                  </p>
                </div>

                <div className="col-md-12 mb-3">
                  <strong>Created On:</strong>
                  <p className="text-muted">
                    {new Date(modalData?.created_on).toLocaleString() || "N/A"}
                  </p>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`modal fade ${modalOpen ? "show" : ""}`}
        id="bs-example-modal-lg"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden={!modalOpen}
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <img
                src="/assets/img/logo/weconnectlogo.png"
                alt=""
                style={{ height: "50px" }}
              />
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setModalOpen(false)}
              />
            </div>
            <div className="modal-body">
              <div className="card-body p-0">
                <Table
                  dataSource={empdata}
                  columns={empcolumns}
                  Selection={false}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TeamattendanceHistory;
